// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1mA2G","range":"MonthRangeSwitch_range__2St2V","disabled":"MonthRangeSwitch_disabled__38Rs0"};